import { render, staticRenderFns } from "./farm-info.vue?vue&type=template&id=6c73a599&scoped=true&"
import script from "./farm-info.vue?vue&type=script&lang=js&"
export * from "./farm-info.vue?vue&type=script&lang=js&"
import style0 from "./farm-info.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./farm-info.vue?vue&type=style&index=1&id=6c73a599&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c73a599",
  null
  
)

export default component.exports